<!-- 下载页面 -->
<template>
  <div>
    <modieDownload v-if="!IsPcFlag"></modieDownload>
    <pcDownload v-if="IsPcFlag"></pcDownload>
  </div>
</template>

<script>
  // 这里可以导入其他文件 (比如：组件，工具js，第三方插件js，json文件，图片文件等等)
  // 例如：import 《组件名称》 from '《组件路径》'
  import modieDownload from './modieDownload.vue';
  import pcDownload from './pcDownload.vue';
  export default {
    name: "download",
    // import引入的组件需要注入到对象中才能使用
    components: {
      modieDownload,
      pcDownload
    },
    data() {
      // 这里存放数据
      return {
        IsPcFlag: false
      };
    },
    // 计算属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      // 跳转至下载页面
      jumpDownload: function () {
        this.IsPcFlag = this.IsPC();
      },
      // 判断是PC端还是移动端
      IsPC: function () {
        // 当前设备信息
        let userAgentInfo = navigator.userAgent;
        let Agents = [
          "Android",
          "iPhone",
          "SymbianOS",
          "Windows Phone",
          "iPad",
          "iPod",
          "webOS",
          "BlackBerry"
        ];
        let flag = true;
        // 如果能匹配到上面的字符串 就说明是移动端
        for (let v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        };
        // true为PC端 false为移动端
        return flag;
      }
    },
    // 生命周期 - 创建完成 (可以访问当前this实例)
    created() {
      this.jumpDownload()
    },
    // 生命周期 - 挂载完成 (可以访问DOM元素)
    mounted() {},
    // 生命周期 - 销毁之前
    beforeDestroy() {},
    // 生命周期 - 销毁完成
    destroyed() {},
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* @import url(路径); 引入公共css类 */
</style>


// WEBPACK FOOTER //
// src/components/download.vue